<template>
  <v-row align="center"
         justify="center">
    <v-col cols="12"
           sm="8">
      <change-password-form>
      </change-password-form>
    </v-col>
  </v-row>
</template>
<script>
import ChangePasswordForm from "./components/ChangePasswordForm";

export default {
  components: {ChangePasswordForm},
  metaInfo() {
    this.$store.commit('setTitle', 'Change Password');
    return {
      title: this.$store.getters.title,
    }
  },
}
</script>
